import { ICountry } from 'services/enums/types';
import { ISettlementPeriodName } from 'services/label-report/types';
import { IInfinitePageParams, IInfinitePageResponse } from 'services/types';
import { IErrorResponse } from 'types/service/errorCodes.interface';

export interface IStatementsParam {
  page: number;
  itemCount: number;
}

export interface IStatementsSearch {
  startSettlementPeriodId?: string;
  endSettlementPeriodId?: string;
  salesChannels?: string;
  providers?: string;
  hasUnrelatedRows?: boolean;
}

interface Currency {
  currencyCode: string;
  name: string;
  id: number;
}

interface ExchangeRate {
  currencyId: number;
  currency: Currency;
  rate: number;
  exchangeRateDate: string;
  tableCode: string;
}

interface IStatementConsistency {
  name: string;
  id: STATEMENT_CONSISTANCY;
}

export enum CURRENCY_ID {
  PLN = 1,
  USD = 2,
  EUR = 3,
  CHF = 4,
  GBP = 5,
}

export interface IStatement {
  id: string;
  salesChannelId: string;
  settlementPeriodId: string;
  statementStatus: STATEMENT_STATUS;
  consistency?: STATEMENT_CONSISTANCY;
  generalConsistency?: IStatementConsistency | null;
  detailedConsistency?: IStatementConsistency | null;
  defaultCurrency: any;
  defaultTotalValue: number;
  statementFileId: string;
  statementFilePath: string;
  settlementPeriodName: ISettlementPeriodName;
  salesChannelName: string;
  providerId: string;
  providerName: string;
  errors: IErrorResponse[];
  exchangeRates: ExchangeRate[];
  hasUnrelatedRows?: boolean;
}
export interface IStatementRows {
  id: string;
  statementId: string;
  ean: string | null;
  isrc: string | null;
  channelId: string;
  videoId: string;
  assetId: string;
  salesPeriodFrom: string;
  salesPeriodTo: string;
  quantity: number;
  unitPrice: number;
  totalValue: number;
  defaultUnitPrice: number;
  defaultTotalValue: number;
  ok: boolean;
  countryCode: string;
  currencyId: number;
  defaultCurrencyId: number;
  currency: Currency;
  defaultCurrency: Currency;
  country: ICountry;
  createdAt: string;
  editedAt: string | null;
}

export interface IStatementsResponse
  extends IInfinitePageResponse<IStatement> {}

export interface IStatementStatistics {
  allAmount: number;
}

export interface ChunkUploadParams {
  file: File;
  salesChannelId: string;
  providerId: string;
  settlementPeriodId: string;
  templateType: string;
  currencyId?: number | null;
  onProgress?: (progress: number) => void;
}

export interface ChunkUploadResponse {
  value: boolean;
  isSuccess: boolean;
  isFailure: boolean;
  errors: string[];
}

export interface IStatementImportPayload {
  SalesChannelId: string;
  SettlementPeriodId: string;
  File: File | null;
  ProviderId: string;
  CurrencyId?: number | null;
}

export interface IStatementImportResponse {
  name: string;
  [key: string]: any;
}

export interface IStatementRowsParams {
  StatementId: string;
  ItemCount: number;
  Page: number;
}

export interface IStatementUnrelatedRowsStatistics {
  allNetAmount: number;
}

export interface IStatementUnrelatedRowsFilterParams extends IInfinitePageParams {
  ean?: string;
  isrc?: string;
  channelId?: string;
  videoId?: string;
  assetId?: string;
}

export interface IStatementSummaryRowsFilterParams extends IInfinitePageParams {
  ean?: string;
  isrc?: string;
  channelId?: string;
  videoId?: string;
  assetId?: string;
}

export interface IStatementRowsFilterParams extends IInfinitePageParams {
  ean?: string;
  isrc?: string;
  channelId?: string;
  videoId?: string;
  assetId?: string;
}

export interface IStatementsRowsResponse
  extends IInfinitePageResponse<IStatementRows> {}

export enum STATEMENT_STATUS {
  unknown = -1,
  waiting = 1,
  done = 2,
  error = 3,
  canceled = 4,
  accepted = 5,
  inProgress = 6,
}

export enum STATEMENT_CONSISTANCY {
  consistent = 1,
  partiallyConsistent = 2,
  inconsistent = 3,
}
